import { z } from 'zod'

export const LoyaltyBackgroundSchema = z.enum(['primary', 'secondary'])
export const LoyaltyBackgroundTint = {
  primary: 'bg-loyalty-primary',
  secondary: 'bg-loyalty-secondary',
} as const

export const LoyaltyIconTint = {
  primary: '[&_path]:fill-loyalty-primary [&_path]:stroke-loyalty-primary',
  secondary: '[&_path]:fill-loyalty-secondary [&_path]:stroke-loyalty-secondary',
}

export const LoyaltyTextTint = {
  primary: 'text-loyalty-primary',
  secondary: 'text-loyalty-secondary',
  white: 'text-white',
} as const
